export const onChangeSkinTone = () => ({
  type: 'CHANGE_SKIN_TONE'
})

export const onSetSkinToneIndex = (index) => ({
  type: 'SET_SKIN_TONE_INDEX',
  index
})
